/*
 * File: DashboardHome.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the main dashboard page
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import RenderAppointments from "./RenderAppointments";
import RenderOrders from "./RenderOrders";
import WelcomeUser from "./components/WelcomeUser";
import PersonIcon from "@material-ui/icons/Person";
import PatientCreatePage from "services/patients/demographics/patient_info/components/PatientCreatePage";
import UIFormDialog from "components/ui/UIFormDialog";
import PatientStore from "services/patients/store/PatientStore";
import UIFab from "components/ui/UIFab";
import RecentPatients from "./components/RecentPatients";
import { useStore } from "utils/useStore";

const DashboardHome = ({ didLoad, history }) => {
  const [showFormDialog, setShowFormDialog] = useState(false);
  const patientStore = useStore(PatientStore);
  let className;

  let formCallBack = patientId => {
    history.push("/patients/" + patientId + "/patient_home");
  };

  let createAccount = (
    <PatientCreatePage
      parentCallBack={formCallBack}
      patient={patientStore.newPatient}
      createNewAccount={true}
      toggleFormDialog={() => toggleDialog()}
    />
  );

  let toggleDialog = () => {
    setShowFormDialog(!showFormDialog);
  };

  // we only want to fadeInUp on the initial load, not subsequent views
  if (didLoad === false) className = "animated fadeInUp";

  return (
    <div className="gradient padding">
      <div className={className}>
        <WelcomeUser />
        <RenderAppointments />
        <RenderOrders />
        <RecentPatients />
      </div>
      <UIFab
        icon={<PersonIcon />}
        handleClick={toggleDialog}
        name={"New Account"}
      />

      <UIFormDialog
        open={showFormDialog}
        toggleDialog={toggleDialog}
        title="Add Patient in New Account"
        viewPage={() => createAccount}
      />
    </div>
  );
};

DashboardHome.propTypes = {
  // indicator for the fade animation
  didLoad: PropTypes.bool,
  history: PropTypes.object.isRequired
};

export default DashboardHome;
